import { render, staticRenderFns } from "./snContact.vue?vue&type=template&id=a9da0682&scoped=true&"
import script from "./snContact.vue?vue&type=script&lang=js&"
export * from "./snContact.vue?vue&type=script&lang=js&"
import style0 from "./snContact.vue?vue&type=style&index=0&id=a9da0682&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9da0682",
  null
  
)

export default component.exports